import React from "react";
import { useParams } from "react-router-dom";
import { blogs } from "../data/blogs";

const BlogDetail = () => {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) {
    return <h2>Blog not found!</h2>;
  }

  return (
    <>
      {/* Banner Section */}
      <section className="inner-banner-sec">
        <div className="container-fluid add-padding-2">
          <div className="inner-bg-img">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 align-self-center">
                <div
                  className="banner_text wow fadeInLeft"
                  data-wow-duration="2s"
                >
                  <h1>
                    <span>{blog.title}</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="latest-travel inn-det">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div
                className="lat-img wow fadeInLeft"
                data-wow-duration="2s"
              >
                <img src={blog.image} alt={blog.title} />
              </div>

              <div className="lat-bt-txt">
                <div className="lat-fea">
                  <h6>
                    <i className="fa-regular fa-user" aria-hidden="true"></i> by{" "}
                    {blog.author}
                  </h6>
                </div>

                <h4>{blog.title}</h4>
                <div
                  dangerouslySetInnerHTML={{ __html: blog.content }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </>
  );
};

export default BlogDetail;
